import { Component, OnInit, Input, OnChanges, SimpleChange, ElementRef, Output, EventEmitter } from '@angular/core';
import {Warehouse, Warehouse1} from '../../project/warehouse';
import {Frame1Component} from '../frames/frame1.component';
import * as d3 from 'd3';


@Component({
  selector: 'app-wind-column1',
  templateUrl: './wind-columns.component.html'
})
export class WindColumn1Component extends Frame1Component implements OnInit,  OnChanges {

  @Input() b: boolean;
  @Input() max_sep: number;

  constructor(el: ElementRef) {
    super(el);
    this.div = "#wind-column";
  }

  ngOnInit(){
    this.width = 400 - this.margin.left - this.margin.right;
    this.height = 400 - this.margin.top - this.margin.bottom;
    this.initFrame();
    this.isInit = true;

  }

  ngOnChanges(){
      if(this.isInit) {
        this.svg.selectAll(".wind-column").remove();
        if(this.max_sep > 0) {
            this.createWindColumns();
        }
      }
  }

  initFrame(){
    this.prepareData();
    this.createFrame();
    this.drawB();
    if(this.data.has_door) {
        this.addDoor();
    }
    if(this.max_sep > 0) {
        this.createWindColumns();
    }
  }
    
    
  createWindColumns() {
      if (!this.data.has_door) {
            let init = this.origin[0];
            let length = this.data.width_l + this.data.width_r;
            let left_height = this.data.height_l;
            this.drawColumns(init, length, left_height, this.data.slope_l, this.data.slope_r, this.data.width_l);
      } else {
            // when has door draw left and right side of the wind columns.
            let init = this.origin[0];
            let length = this.get_center() - this.data.opening_width/2;
            let left_height = this.data.height_l;
            this.drawColumns(init, length, left_height, this.data.slope_l, this.data.slope_r, this.data.width_l);
            init = this.origin[0] + this.get_center() + this.data.opening_width/2;
            length = (this.data.width_l + this.data.width_r) - (this.get_center() + this.data.opening_width/2);
            this.drawColumns(init, length, left_height, this.data.slope_l, this.data.slope_r, this.data.width_l);
      }
  }
    
  drawColumns(init, length, left_height, slope_l, slope_r, width_l){
      let max_sep = this.max_sep * this.factor
      let size = Math.ceil( length / max_sep );
      let separation = (length / size)
      let height : number;
      let distance : number;
      if (!this.data.has_door) size--;
      for(let i = 0; i < size; i++) {
          if (init - this.origin[0] > 0 ) { // Check right side of the wind columns (after the door)
              distance = (init - this.origin[0]) + separation * (i);
          } else { // Left side of the door, or without the door
              distance = separation * (i+1);
          }
          
          if( distance < width_l) {
              height = left_height + distance * slope_l;
          } else {
              height = (left_height + width_l * slope_l) - (distance - width_l ) * slope_r;
          }
          let d = this.svg.append("line")
                  .style("stroke", "#68a2ff")
                  .style("stroke-width", 5)
                  .attr("class", "wind-column")
                  .attr("x1", this.origin[0] + distance)
                  .attr("y1", this.origin[1])
                  .attr("x2", this.origin[0] + distance)
                  .attr("y2", this.origin[1] - height);
      }
  }

  drawB(){
    let bl = this.data.width_l*this.data.slope_l + this.data.hb_additional_height;
    let br = this.data.width_r*this.data.slope_r + this.data.hb_additional_height;
    if(this.b){
      let b = this.svg.append("line")
        .style("stroke", "#68a2ff")
        .style("stroke-width", 3)
        .attr("class", "b")
        .attr("x1", this.origin[0])
        .attr("y1", this.origin[1]-this.data.height_l-this.radio)
        .attr("x2", this.origin[0])
        .attr("y2", this.origin[1]-this.data.height_l-bl);
      b = this.svg.append("line")
        .style("stroke", "#68a2ff")
        .style("stroke-width", 3)
        .attr("class", "b")
        .attr("x1", this.origin[0]+this.data.width_l+this.data.width_r)
        .attr("y1", this.origin[1]-this.data.height_r-this.radio)
        .attr("x2", this.origin[0]+this.data.width_l+this.data.width_r)
        .attr("y2", this.origin[1]-this.data.height_r-br);
    } else {
      this.svg.selectAll(".b").remove();
    }
  }
      
  get_center() {
      return (this.data.width_l + this.data.width_r) / 2
  }
    
  addDoor(){
    let width = this.data.opening_width;
    let height = this.data.opening_height;
    let padding = this.get_center() - width/2;
    let d1 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "d1")
      .attr("x1", this.origin[0] + padding)
      .attr("y1", this.origin[1])
      .attr("x2", this.origin[0] + padding)
      .attr("y2", this.origin[1] - height);
    let d2 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "d2")
      .attr("x1", this.origin[0] + padding)
      .attr("y1", this.origin[1] - height)
      .attr("x2", this.origin[0] + padding + width)
      .attr("y2", this.origin[1] - height);
    let d3 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "d3")
      .attr("x1", this.origin[0] + padding + width)
      .attr("y1", this.origin[1] - height)
      .attr("x2", this.origin[0] + padding + width)
      .attr("y2", this.origin[1]);
    let circle1 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0] + padding)
      .attr("cy", this.origin[1])
      .attr("r", this.radio);
    let circle2 = this.svg.append("circle")
    .style("fill", "#77768d")
      .attr("cx", this.origin[0] + padding)
      .attr("cy", this.origin[1] - height)
      .attr("r", this.radio);
    let circle3 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0] + padding + width)
      .attr("cy", (this.origin[1] - height))
      .attr("r", this.radio);
    let circle4 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0] + padding + width)
      .attr("cy", this.origin[1])
      .attr("r", this.radio);
  }

  
}



// WEBPACK FOOTER //
// ./src/app/sketch/wind-columns/wind-column1.component.ts